// 派发GA事件
export const useDispatchGAEvent = (event, params) => {
    const eventName = window?.igws?.GAEvents?.[event];
    window?.observer?.dispatch?.(eventName, params);

    // 触发自定义事件，以解决其它BU想要在其它平台获取这些点击数据，例如us想要上报给Klavyio
    window.dispatchEvent(new CustomEvent(eventName, {
        detail: params,
    }));
}